import { Box, Header } from '@rbilabs/universal-components';

import { ModalContent as OriginalModalContent } from 'components/modal';

import { ADDRESS_MODAL_WIDTH_DESKTOP } from './constants';

export const ModalHeading = Box.withConfig({
  marginX: '0',
  width: 'full',
  maxWidth: 'full',
  paddingX: '$6',
});

export const ModalContent = OriginalModalContent.withConfig({
  width: { base: 'full', md: ADDRESS_MODAL_WIDTH_DESKTOP },
  paddingX: { base: '$8', md: '$0' },
  alignSelf: 'center',
});

export const ModalTitle = Header.withConfig({
  variant: 'headerOne',
  paddingBottom: '$6',
  textAlign: 'center',
});
